// LIST
export const FETCH_EMPLOYEE = "app/EMPLOYEE/FETCH_EMPLOYEE";
export const FETCH_EMPLOYEE_SUCCESS = "app/EMPLOYEE/FETCH_EMPLOYEE_SUCCESS";
export const FETCH_EMPLOYEE_FAILURE = "app/EMPLOYEE/FETCH_EMPLOYEE_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/EMPLOYEE/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/EMPLOYEE/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/EMPLOYEE/GET_VIEW_DATA_FAILURE";
// ADD
export const ADD_EMPLOYEE = "app/EMPLOYEE/ADD_EMPLOYEE";
export const ADD_EMPLOYEE_SUCCESS = "app/EMPLOYEE/ADD_EMPLOYEE_SUCCESS";
export const ADD_EMPLOYEE_FAILURE = "app/EMPLOYEE/ADD_EMPLOYEE_FAILURE";
// EDIT
export const EDIT_EMPLOYEE = "app/EMPLOYEE/EDIT_EMPLOYEE";
export const EDIT_EMPLOYEE_SUCCESS = "app/EMPLOYEE/EDIT_EMPLOYEE_SUCCESS";
export const EDIT_EMPLOYEE_FAILURE = "app/EMPLOYEE/EDIT_EMPLOYEE_FAILURE";
// DELETE
export const DELETE_EMPLOYEE = "app/EMPLOYEE/DELETE_EMPLOYEE";
export const DELETE_EMPLOYEE_SUCCESS = "app/EMPLOYEE/DELETE_EMPLOYEE_SUCCESS";
export const DELETE_EMPLOYEE_FAILURE = "app/EMPLOYEE/DELETE_EMPLOYEE_FAILURE";

export const DEFAULT_PERMS = "app/EMPLOYEE/DEFAULT_PERMS";
export const SET_CURRENT_PERMS = "app/EMPLOYEE/SET_CURRENT_PERMS";

export const SEARCH_EMPLOYEE = "app/EMPLOYEE/SEARCH_EMPLOYEE";
export const SEARCH_EMPLOYEE_SUCCESS = "app/EMPLOYEE/SEARCH_EMPLOYEE_SUCCESS";
export const SEARCH_EMPLOYEE_FAILURE = "app/EMPLOYEE/SEARCH_EMPLOYEE_FAILURE";

export const SAVE_INFO = "app/EMPLOYEE/SAVE_INFO";
export const SAVE_INFO_SUCCESS = "app/EMPLOYEE/SAVE_INFO_SUCCESS";
export const SAVE_INFO_FAILURE = "app/EMPLOYEE/SAVE_INFO_FAILURE";

export const SAVE_DOCS = "app/EMPLOYEE/SAVE_DOCS";
export const SAVE_DOCS_SUCCESS = "app/EMPLOYEE/SAVE_DOCS_SUCCESS";
export const SAVE_DOCS_FAILURE = "app/EMPLOYEE/SAVE_DOCS_FAILURE";

export const SAVE_SCHEDULE = "app/EMPLOYEE/SAVE_SCHEDULE";
export const SAVE_SCHEDULE_SUCCESS = "app/EMPLOYEE/SAVE_SCHEDULE_SUCCESS";
export const SAVE_SCHEDULE_FAILURE = "app/EMPLOYEE/SAVE_SCHEDULE_FAILURE";

export const SEND_INVITE = "app/EMPLOYEE/SEND_INVITE";
export const SEND_INVITE_SUCCESS = "app/EMPLOYEE/SEND_INVITE_SUCCESS";
export const SEND_INVITE_FAILURE = "app/EMPLOYEE/SEND_INVITE_FAILURE";

export const TOGGLE_PIN_MODAL = "app/EMPLOYEE/TOGGLE_PIN_MODAL";
export const TOGGLE_MAIL_MODAL = "app/EMPLOYEE/TOGGLE_MAIL_MODAL";
export const TOGGLE_IMAGE_MODAL = "app/EMPLOYEE/TOGGLE_IMAGE_MODAL";

export const SAVE_PROFILE = "app/EMPLOYEE/SAVE_PROFILE";
export const SAVE_PROFILE_SUCCESS = "app/EMPLOYEE/SAVE_PROFILE_SUCCESS";
export const SAVE_PROFILE_FAILURE = "app/EMPLOYEE/SAVE_PROFILE_FAILURE";

export const TOGGLE_DOC_MODAL = "app/EMPLOYEE/TOGGLE_DOC_MODAL";

export const SAVE_PAYROLL = "app/EMPLOYEE/SAVE_PAYROLL";
export const SAVE_PAYROLL_SUCCESS = "app/EMPLOYEE/SAVE_PAYROLL_SUCCESS";
export const SAVE_PAYROLL_FAILURE = "app/EMPLOYEE/SAVE_PAYROLL_FAILURE";

export const DELETE_DOC = "app/EMPLOYEE/DELETE_DOC";
export const DELETE_DOC_SUCCESS = "app/EMPLOYEE/DELETE_DOC_SUCCESS";
export const DELETE_DOC_FAILURE = "app/EMPLOYEE/DELETE_DOC_FAILURE";

export const SAVE_PIN = "app/EMPLOYEE/SAVE_PIN";
export const SAVE_PIN_SUCCESS = "app/EMPLOYEE/SAVE_PIN_SUCCESS";
export const SAVE_PIN_FAILURE = "app/EMPLOYEE/SAVE_PIN_FAILURE";

export const SEND_MAIL = "app/EMPLOYEE/SEND_MAIL";
export const SEND_MAIL_SUCCESS = "app/EMPLOYEE/SEND_MAIL_SUCCESS";
export const SEND_MAIL_FAILURE = "app/EMPLOYEE/SEND_MAIL_FAILURE";

export const UPLOAD_CSV = "app/EMPLOYEE/UPLOAD_CSV";
export const UPLOAD_CSV_SUCCESS = "app/EMPLOYEE/UPLOAD_CSV_SUCCESS";
export const UPLOAD_CSV_FAILURE = "app/EMPLOYEE/UPLOAD_CSV_FAILURE";

export const SEARCH_MANAGER = "app/EMPLOYEE/SEARCH_MANAGER";
export const SEARCH_MANAGER_SUCCESS = "app/EMPLOYEE/SEARCH_MANAGER_SUCCESS";
export const SEARCH_MANAGER_FAILURE = "app/EMPLOYEE/SEARCH_MANAGER_FAILURE";

export const IMPORT_CSV = "app/EMPLOYEE/IMPORT_CSV";
export const IMPORT_CSV_SUCCESS = "app/EMPLOYEE/IMPORT_CSV_SUCCESS";
export const IMPORT_CSV_FAILURE = "app/EMPLOYEE/IMPORT_CSV_FAILURE";

export const TOGGLE_LEAVE_CALC = "app/EMPLOYEE/TOGGLE_LEAVE_CALC";

export const GET_EMP_HISTORY = "app/EMPLOYEE/GET_EMP_HISTORY";
export const GET_EMP_HISTORY_SUCCESS = "app/EMPLOYEE/GET_EMP_HISTORY_SUCCESS";
export const GET_EMP_HISTORY_FAILURE = "app/EMPLOYEE/GET_EMP_HISTORY_FAILURE";

export const TOGGLE_HISTORY_MODAL = "app/EMPLOYEE/TOGGLE_HISTORY_MODAL";

export const GET_BIRTHDAYS = "app/EMPLOYEE/GET_BIRTHDAYS";
export const GET_BIRTHDAYS_SUCCESS = "app/EMPLOYEE/GET_BIRTHDAYS_SUCCESS";
export const GET_BIRTHDAYS_FAILURE = "app/EMPLOYEE/GET_BIRTHDAYS_FAILURE";

export const GET_EXPIRING_DOCS = "app/EMPLOYEE/GET_EXPIRING_DOCS";
export const GET_EXPIRING_DOCS_SUCCESS =
  "app/EMPLOYEE/GET_EXPIRING_DOCS_SUCCESS";
export const GET_EXPIRING_DOCS_FAILURE =
  "app/EMPLOYEE/GET_EXPIRING_DOCS_FAILURE";

export const GET_EMPTY_SHIFTS = "app/EMPLOYEE/GET_EMPTY_SHIFTS";
export const GET_EMPTY_SHIFTS_SUCCESS = "app/EMPLOYEE/GET_EMPTY_SHIFTS_SUCCESS";
export const GET_EMPTY_SHIFTS_FAILURE = "app/EMPLOYEE/GET_EMPTY_SHIFTS_FAILURE";

export const GET_EMPTY_CLOCKS = "app/EMPLOYEE/GET_EMPTY_CLOCKS";
export const GET_EMPTY_CLOCKS_SUCCESS = "app/EMPLOYEE/GET_EMPTY_CLOCKS_SUCCESS";
export const GET_EMPTY_CLOCKS_FAILURE = "app/EMPLOYEE/GET_EMPTY_CLOCKS_FAILURE";

export const SEARCH_ROTA_EMPLOYEE = "app/EMPLOYEE/SEARCH_ROTA_EMPLOYEE";
export const SEARCH_ROTA_EMPLOYEE_SUCCESS =
  "app/EMPLOYEE/SEARCH_ROTA_EMPLOYEE_SUCCESS";
export const SEARCH_ROTA_EMPLOYEE_FAILURE =
  "app/EMPLOYEE/SEARCH_ROTA_EMPLOYEE_FAILURE";
